import {Model} from '@vuex-orm/core';

export default class SeminarLocation extends Model {

    static entity = 'seminarLocation';

    static fields() {
        return {
            id: this.increment(),
            address: this.attr({
                street: '',
                street_number: '',
                post_code: '',
                city: '',
                country: null,
            }),
            country_state: this.attr(null),
            event_start: this.attr(null),
            event_end: this.attr(null),
            admin: this.attr([]),
            member_limit: this.attr(0),
        };
    }
}